export const LOGGED_OUT = "LOGGED_OUT";
export const LOGGED_IN = "LOGGED_IN";
export const UNKNOWN_LOGIN_STATUS = "UNKNOWN_LOGIN_STATUS";
